import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Routes from './Routes';
import Logger from './functions/logging';

import { UnavailableLayout } from './layouts/layouts';

// import settings from './libs/config';
import * as geoFns from './functions/geolocation';

import { setCurrentUserLocation } from './redux/actions/index';

class App extends Component {
	constructor(props) {
		super(props);

		this.state = {
			locationRestricted: null
		};
	}

	/* TODO: Uncomment this when we want to implement location restrictions
		componentDidMount() {
			if (!this.state.locationRestricted && !geoFns.loadUserLocation()) {
				this.getUserLocation();
			}
		}
	*/

	async getUserLocation() {
		Logger.log(this.constructor.name, "getUserLocation()");
		try {
			const userLocation = await geoFns.fetchUserLocation();
			Logger.log(this.constructor.name, "getUserLocation() result", userLocation);

			geoFns.storeUserLocation(userLocation);
			this.props.setCurrentUserLocation(userLocation);

			await this.checkLocationRestrictions(userLocation);
		}
		catch (error) {
			Logger.error(this.constructor.name, "getUserLocation() error", error);
		}
	}

	async checkLocationRestrictions(userLocation) {
		Logger.log(this.constructor.name, "checkLocationRestrictions()");
		try {
			const isUserInEU = userLocation && userLocation.is_eu;

			Logger.log(this.constructor.name, "checkLocationRestrictions() result", isUserInEU);

			//
			// TODO: If we ever want to implement a robust restriction, need to ensure
			// user can't bypass by just editing localStorage data.
			//
			const restrict = false;
			if (restrict) {
				// persistent.setSessionValue("is_eu", true);
				this.setState({ locationRestricted : true });
			}
			else {
				// persistent.removeSessionValue("is_eu");
				this.setState({ locationRestricted: false });
			}
		}
		catch (error) {
			Logger.error(this.constructor.name, "checkLocationRestrictions() error", error);
		}
	}

	render() {
		Logger.log(this.constructor.name, "App render()", this.props);

		let body = Routes;

		if (this.state.locationRestricted) {
			body = <UnavailableLayout />;
		}

		return (
			<div className="pilotly-app">
				{body}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		currentUserLocation: state.currentUser.currentUserLocation,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		setCurrentUserLocation
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js